"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StreamPlayer = require("./StreamPlayer");
Object.keys(_StreamPlayer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StreamPlayer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StreamPlayer[key];
    }
  });
});